const defaultEndpoint = '/abtesting/sendhit';

function withParam(endpoint, name, value) {
  if (!value) {
    return endpoint;
  }

  const separator = endpoint.includes('?') ? '&' : '?';
  return `${endpoint}${separator}${name}=${encodeURIComponent(value)}`;
}

export function sendAbTestingHit(eventName, label) {
  let url = withParam(defaultEndpoint, 'eventName', eventName);
  url = withParam(url, 'label', label);

  return fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    keepalive: true,
  });
}

export function sendAbTestingTransactionHit(transactionData) {
  return fetch('/abtesting/sendtransactionhit', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    keepalive: true,
    body: JSON.stringify(transactionData),
  });
}
